import actions from './actions';

const state = {
  orderGeneralList: [],
};

export default {
  namespaced: true,
  state,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/orderGeneral/index.js